import React from "react";
import "./Nav.css";
import { HiMenuAlt2 } from "react-icons/hi";

function Nav({ setSectionCount }) {
  return (
    <div id="Nav" className="Nav">
      <HiMenuAlt2 size={30} />
      <h2 className="nav__text">childVision</h2>
    </div>
  );
}

export default Nav;
